enum FetchStatusEnum {
    UNINITIALIZED,
    PENDING,
    DONE,
    FAILED
}

export default FetchStatusEnum;
